import React from "react";
import ReactLoading from "react-loading";

import loadingAnimationWhite from "assets/img/loading-animation-white.gif";
import loadingAnimation from "assets/img/loading-animation.gif";
import { isIe } from "utils/helpers";

interface LoadingProps {
  width?: number;
  height?: number;
  color?: string;
}

const TextLineLoader: React.FC<LoadingProps> = ({
  width = 16,
  height = 16,
  color = "#E5B611",
}) => (
  <span
    style={{
      display: "inline-flex",
      alignItems: "center",
      marginLeft: 4,      
      marginTop: 1,       
      verticalAlign: "middle",
    }}
  >
    {!isIe ? (
      <ReactLoading type="spin" color={color} height={height} width={width} />
    ) : (
      <img
        src={color === "#fff" ? loadingAnimationWhite : loadingAnimation}
        alt="Loading..."
        style={{ width, height }}
      />
    )}
  </span>
);

export default TextLineLoader;
